import { MigrationStrategies } from 'rxdb';

/**
 * Keeps the quotes stored by schema v1. Their signed PDF is unknown until the
 * stream refetches them (see ENTITY_RESYNC_VERSIONS in streamUpdateV3/storage.ts).
 */
export const migrateProposalToV2 = (oldDoc) => ({ ...oldDoc, signedPdfUrl: null });

/**
 * Strategies for versions above the shared dbVersion (1). They are merged with
 * the shared strategies in DbManager.addCollections.
 */
const proposalMigrationStrategies: MigrationStrategies = {
  2: migrateProposalToV2,
};

export default proposalMigrationStrategies;
